// extracted by mini-css-extract-plugin
export default {"enrichment_jarm":"enrichment-jarm_enrichment_jarm__kcogO","jarm_value":"enrichment-jarm_jarm_value__UwFeQ"};